export default __webpack_public_path__ + "static/media/play-white.50c1be86.jpeg";